<div class="date-input-root">
  <button type="button" class="date-input-trigger" [class.disabled]="disabled" (click)="toggleOpen()">
    <i class="fas fa-calendar-alt text-gray-400 mr-2"></i>
    <span [class.placeholder]="!value">{{ displayLabel }}</span>
    <i *ngIf="value" class="fas fa-times text-gray-300 ml-auto hover:text-gray-500" (click)="clear($event)"></i>
  </button>

  <div class="date-input-popup" *ngIf="isOpen">
    <div class="popup-header">
      <button type="button" class="nav-btn" (click)="previousMonth()"><i class="fas fa-chevron-left"></i></button>
      <span class="month-label">{{ viewMonthLabel }}</span>
      <button type="button" class="nav-btn" (click)="nextMonth()"><i class="fas fa-chevron-right"></i></button>
    </div>
    <div class="weekday-row">
      <span *ngFor="let w of weekdayLabels">{{ w }}</span>
    </div>
    <div class="day-grid">
      <button type="button" *ngFor="let cell of calendarCells" class="day-cell"
        [class.muted]="!cell.isCurrentMonth" [class.selected]="cell.isSelected" [class.today]="cell.isToday && !cell.isSelected"
        (click)="selectDay(cell.iso)">
        {{ cell.date }}
      </button>
    </div>
  </div>
</div>
